<template>
  <div class="lxm-menu-panel">
    <div class="lxm-menu-panel__background" @click="backgroundClicked"></div>
    <img class="lxm-menu-panel__triangle" src="../../images/main/dashboard/triangle.png" />
    <lxm-panel class="lxm-menu-panel__panel"
               :rows="rows"
               :panelStyle="{ padding: `0 ${50 / 2 / 14}rem 0 ${55 / 2 / 14}rem` }"
               :panelBlockStyle="{}"></lxm-panel>
  </div>
</template>

<style lang="stylus" scoped>
  @import '../../styles/index.styl'
  .lxm-menu-panel
    position: fixed
    width: 100vw
    height: 100vh
    z-index: 1
    top: 0
    left: 0
  .lxm-menu-panel__background
    width: 100%
    height: 100%
    background-color: rgba(0, 0, 0, 0.6)
  .lxm-menu-panel__triangle
    width: siz(15)
    height: siz(16.5)
    position: absolute
    top: siz(30)
    right: siz(31.5)
  .lxm-menu-panel__panel
    position: absolute
    top: siz(35)
    right: siz(35)
    width: siz(142)
</style>

<script>
  /* global $: false */
  import LxmPanel from './LxmPanel.vue'
  import * as aTypes from '../../../store/action-types'
  export default {
    components: {
      LxmPanel
    },
    computed: {
      rows () {
        const help = {
          key: {
            iconClass: 'lxm-panel__icon--question',
            text: '帮助中心'
          },
          href: 'http://help.lingxi360.com/',
          clicked: () => {
            this.$store.dispatch(aTypes.ZHUGE_TRACK, { event: '点帮助中心' })
          }
        }
        /*
        const checkIn = {
          key: {
            iconClass: 'lxm-panel__icon--check-in',
            text: '快捷签到'
          }
        }
        */
        const userSupport = {
          key: {
            iconClass: 'lxm-panel__icon--chat',
            text: '呼叫小助手'
          },
          clicked: () => {
            window.ud.init()
            window.ud.showPanel()
            this.$store.dispatch(aTypes.ZHUGE_TRACK, { event: '点小助手' })
          }
        }
        const logout = {
          key: {
            iconClass: 'lxm-panel__icon--power-off',
            text: '登出'
          },
          clicked: () => {
            this.$store.dispatch(aTypes.LOGOUT)
            this.$store.dispatch(aTypes.ZHUGE_TRACK, { event: '点登出' })
          },
          loading: this.$store.state.loading[aTypes.LOGOUT]
        }

        const userSupportEnabled = window.X.services.user_support.enable && this.$store.state.userSupportSetuped
        if (userSupportEnabled) {
          return [help, userSupport, logout]
        } else {
          return [help, logout]
        }
      }
    },
    mounted () {
      const $menuPanel = $(this.$el)
      $menuPanel.fadeOut(0)
    },
    methods: {
      show () {
        const $menuPanel = $(this.$el)
        $menuPanel.fadeIn({
          duration: 400,
          queue: true
        })
        this.$store.dispatch(aTypes.ZHUGE_TRACK, { event: '点击右上角菜单' })
      },
      backgroundClicked () {
        const $menuPanel = $(this.$el)
        $menuPanel.fadeOut({
          duration: 400,
          queue: true
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LxmMenuPanel.vue?0e45b8d9